// iPhone Safari Cart Fix - CORRECTED VERSION
(function () {
  "use strict";

  // Check if we're on iPhone Safari
  const isIPhoneSafari =
    /iPhone/.test(navigator.userAgent) &&
    /Safari/.test(navigator.userAgent) &&
    !/Chrome/.test(navigator.userAgent);

  if (!isIPhoneSafari) {
    return;
  }

  console.log("📱 iPhone Safari detected - applying CORRECTED cart fix...");

  // Get sections to render (required for renderContents)
  function getSectionsToRender() {
    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === "function") {
      return cartDrawer.getSectionsToRender();
    }
    // Fallback sections if method doesn't exist
    return [
      { id: "cart-drawer", section: "cart-drawer" },
      { id: "cart-icon-bubble", section: "cart-icon-bubble" }
    ];
  }

  // Properly fetch cart with sections for renderContents
  function fetchCartWithSections() {
    const sections = getSectionsToRender();
    const sectionIds = sections.map(section => section.id || section.section);
    
    // Construct URL with sections parameter
    const url = new URL('/cart', window.location.origin);
    url.searchParams.append('sections', sectionIds.join(','));
    url.searchParams.append('sections_url', window.location.pathname);

    return fetch(url.toString(), {
      method: 'GET',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      }
    })
    .then(response => response.json())
    .catch(() => {
      // Fallback to simple cart.js if sections fail
      return fetch('/cart.js').then(response => response.json());
    });
  }

  // Safe renderContents wrapper
  function safeRenderContents(cartDrawer, data) {
    try {
      if (typeof cartDrawer.renderContents === "function") {
        // If data has sections (proper format for renderContents)
        if (data && typeof data === 'object' && Object.keys(data).some(key => key.includes('-'))) {
          cartDrawer.renderContents(data);
        } else {
          // Data is cart object, need to fetch sections
          fetchCartWithSections().then(sectionsData => {
            if (sectionsData && typeof cartDrawer.renderContents === "function") {
              cartDrawer.renderContents(sectionsData);
            }
          });
        }
      }
    } catch (error) {
      console.log("📱 renderContents failed, using fallback method");
      // Fallback: manually update cart count
      if (data && data.item_count !== undefined) {
        updateCartCount(data.item_count);
      }
    }
  }

  // Force update cart drawer with proper error handling
  function forceUpdateCartDrawer() {
    const cartDrawer = document.querySelector("cart-drawer");
    if (!cartDrawer) return;

    fetchCartWithSections()
      .then((data) => {
        // Force the drawer to be visible
        cartDrawer.style.visibility = "visible";
        cartDrawer.style.opacity = "1";
        cartDrawer.classList.add("active");

        // Force inner drawer to slide in
        const drawerInner = cartDrawer.querySelector(".drawer__inner");
        if (drawerInner) {
          drawerInner.style.transform = "translateX(0)";
          drawerInner.style.webkitTransform = "translateX(0)";
        }

        // Add body class
        document.body.classList.add("overflow-hidden");

        // Safely update cart contents
        safeRenderContents(cartDrawer, data);

        // Update cart count as fallback
        if (data.item_count !== undefined) {
          updateCartCount(data.item_count);
        }
      })
      .catch((error) => {
        console.log("📱 Cart update failed:", error);
        // Fallback: just show the drawer
        cartDrawer.style.visibility = "visible";
        cartDrawer.style.opacity = "1";
        cartDrawer.classList.add("active");
      });
  }

  // Update cart count in header
  function updateCartCount(count) {
    const cartCountElements = document.querySelectorAll(
      ".cart-count-bubble, .cart-count, [data-cart-count]"
    );
    cartCountElements.forEach((element) => {
      element.textContent = count;
      if (count > 0) {
        element.style.display = "block";
        element.classList.add("cart-count--active");
      } else {
        element.style.display = "none";
        element.classList.remove("cart-count--active");
      }
    });
  }

  // Override cart drawer open method with error handling
  function fixCartDrawer() {
    const cartDrawer = document.querySelector("cart-drawer");
    if (!cartDrawer) return;

    const originalOpen = cartDrawer.open;
    cartDrawer.open = function () {
      console.log("📱 Opening cart drawer...");
      
      // Force visibility
      this.style.visibility = "visible";
      this.style.opacity = "1";
      this.classList.add("active");

      // Force inner drawer to slide in
      const drawerInner = this.querySelector(".drawer__inner");
      if (drawerInner) {
        drawerInner.style.transform = "translateX(0)";
        drawerInner.style.webkitTransform = "translateX(0)";
      }

      // Add body class
      document.body.classList.add("overflow-hidden");

      // Get fresh cart data and update contents SAFELY
      fetchCartWithSections()
        .then((data) => {
          safeRenderContents(this, data);
        })
        .catch(() => {
          // Call original method as ultimate fallback
          if (typeof originalOpen === "function") {
            try {
              originalOpen.call(this);
            } catch (e) {
              console.log("📱 Original open method also failed");
            }
          }
        });
    };
  }

  // Enhanced product form handling
  function fixProductForm() {
    const productForms = document.querySelectorAll("product-form");
    productForms.forEach((productForm) => {
      const originalHandler = productForm.onSubmitHandler;
      
      productForm.onSubmitHandler = function (evt) {
        evt.preventDefault();

        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton && submitButton.getAttribute("aria-disabled") === "true") {
          return;
        }

        // Show loading state
        if (submitButton) {
          submitButton.setAttribute("aria-disabled", true);
          submitButton.classList.add("loading");
        }
        
        const spinner = this.querySelector(".loading__spinner");
        if (spinner) spinner.classList.remove("hidden");

        // Get form data
        const formData = new FormData(this.form || this);

        // Get sections for proper cart update
        const sections = getSectionsToRender();
        if (sections.length > 0) {
          formData.append(
            "sections",
            sections.map(section => section.id || section.section).join(',')
          );
          formData.append("sections_url", window.location.pathname);
        }

        // Make the request with proper error handling
        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Accept: "application/json",
          },
          credentials: "same-origin",
          body: formData,
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }
            return response.json();
          })
          .then((data) => {
            // Handle success
            if (data.status || data.message) {
              // Error response from Shopify
              throw new Error(data.description || data.message || "Error adding to cart");
            }

            // Success - force update cart drawer
            console.log("📱 Item added successfully, updating cart drawer");
            setTimeout(() => {
              forceUpdateCartDrawer();
            }, 100);
          })
          .catch((error) => {
            console.error("📱 Cart add error:", error);
            // Handle error message display
            if (typeof this.handleErrorMessage === "function") {
              this.handleErrorMessage(error.message || "Failed to add item to cart. Please try again.");
            } else {
              alert(error.message || "Failed to add item to cart. Please try again.");
            }
          })
          .finally(() => {
            // Reset button state
            if (submitButton) {
              submitButton.classList.remove("loading");
              submitButton.removeAttribute("aria-disabled");
            }
            if (spinner) spinner.classList.add("hidden");
          });
      };
    });
  }

  // Apply fixes when page is ready
  function applyFixes() {
    fixCartDrawer();
    fixProductForm();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applyFixes);
  } else {
    applyFixes();
  }

  // Also apply after a delay for dynamic content
  setTimeout(applyFixes, 1000);

  console.log("📱 CORRECTED iPhone Safari cart fix applied");
})();